export const CHANGE_EMAIL_REQUESTS_KEY = 'account-management/change-email-requests';
export const CHANGE_EMAIL_LINK_DURATION = 6;
